import enUtilsLocaleFile from "@payping/utils/locales/en.json";
import faUtilsLocaleFile from "@payping/utils/locales/fa.json";
import { localeNameSpaces } from "@payping/utils/localeUtils";
import enComponentsLocaleFile from "@payping/web-components/locales/i18next_en.json";
import faComponentsLocaleFile from "@payping/web-components/locales/i18next_fa.json";
import enApisLocaleFile from "@payping/api/locales/en.json";
import faApisLocaleFile from "@payping/api/locales/fa.json";

import enWrapperLocaleFile from "./en/translation.json";
import faWrapperLocaleFile from "./fa/translation.json";

type Locales = "en" | "fa";
type Namespaces = string;
type LocaleFile = Record<string, any>;
type NamespaceDefinition = Record<Namespaces, LocaleFile>;
type LocaleResources = Record<Locales, NamespaceDefinition>;

export const localeResources: LocaleResources = {
  en: {
    [localeNameSpaces[localeNameSpaces.Wrapper]]: enWrapperLocaleFile,
    [localeNameSpaces[localeNameSpaces.Utils]]: enUtilsLocaleFile,
    [localeNameSpaces[localeNameSpaces.Components]]: enComponentsLocaleFile,
    [localeNameSpaces[localeNameSpaces.Apis]]: enApisLocaleFile,
  },
  fa: {
    [localeNameSpaces[localeNameSpaces.Wrapper]]: faWrapperLocaleFile,
    [localeNameSpaces[localeNameSpaces.Utils]]: faUtilsLocaleFile,
    [localeNameSpaces[localeNameSpaces.Components]]: faComponentsLocaleFile,
    [localeNameSpaces[localeNameSpaces.Apis]]: faApisLocaleFile,
  },
};
